import { ToothNumberingSystem } from '@dataTypes/chartingPreferences.type'

const UNIVERSAL_TO_FDI: Record<number, number> = {
  1: 18,
  2: 17,
  3: 16,
  4: 15,
  5: 14,
  6: 13,
  7: 12,
  8: 11,
  9: 21,
  10: 22,
  11: 23,
  12: 24,
  13: 25,
  14: 26,
  15: 27,
  16: 28,
  17: 38,
  18: 37,
  19: 36,
  20: 35,
  21: 34,
  22: 33,
  23: 32,
  24: 31,
  25: 41,
  26: 42,
  27: 43,
  28: 44,
  29: 45,
  30: 46,
  31: 47,
  32: 48,
}

const getPalmerQuadrantPosition = (universalToothNumber: number): number => {
  if (universalToothNumber >= 1 && universalToothNumber <= 8) {
    return 9 - universalToothNumber
  }
  if (universalToothNumber >= 9 && universalToothNumber <= 16) {
    return universalToothNumber - 8
  }
  if (universalToothNumber >= 17 && universalToothNumber <= 24) {
    return 25 - universalToothNumber
  }
  if (universalToothNumber >= 25 && universalToothNumber <= 32) {
    return universalToothNumber - 24
  }
  return universalToothNumber
}

export type PalmerQuadrant = 'ur' | 'ul' | 'll' | 'lr'

const PALMER_QUADRANT_BY_INDEX: Record<number, PalmerQuadrant> = {
  1: 'ur',
  2: 'ul',
  3: 'll',
  4: 'lr',
}

export const getPalmerQuadrantIndex = (
  universalToothNumber: number,
): number => {
  if (universalToothNumber >= 1 && universalToothNumber <= 8) {
    return 1
  }
  if (universalToothNumber >= 9 && universalToothNumber <= 16) {
    return 2
  }
  if (universalToothNumber >= 17 && universalToothNumber <= 24) {
    return 3
  }
  if (universalToothNumber >= 25 && universalToothNumber <= 32) {
    return 4
  }
  return 0
}

export const getPalmerToothDisplay = (
  universalToothNumber: number,
): { position: number; quadrant: PalmerQuadrant } | null => {
  const quadrantIndex = getPalmerQuadrantIndex(universalToothNumber)
  const quadrant = PALMER_QUADRANT_BY_INDEX[quadrantIndex]
  if (!quadrant) {
    return null
  }
  return {
    position: getPalmerQuadrantPosition(universalToothNumber),
    quadrant,
  }
}

const formatPalmerToothNumber = (universalToothNumber: number): string => {
  const palmer = getPalmerToothDisplay(universalToothNumber)
  if (!palmer) {
    return String(universalToothNumber)
  }
  return String(palmer.position)
}

export const formatToothNumberForDisplay = (
  universalToothNumber: number,
  numberingSystem: ToothNumberingSystem,
): string => {
  if (numberingSystem === 'fdi') {
    return String(
      UNIVERSAL_TO_FDI[universalToothNumber] ?? universalToothNumber,
    )
  }
  if (numberingSystem === 'palmer') {
    return formatPalmerToothNumber(universalToothNumber)
  }
  return String(universalToothNumber)
}
